import React from 'react'
import UpgradeMembershipTaskListForm from '../../features/MembershipTaskList/UpgradeMembershipTaskListForm'

const UpgradeMembershipTaskList = () => {
    return (
        <div>
            <UpgradeMembershipTaskListForm />
        </div>
    )
}

export default UpgradeMembershipTaskList